import React from 'react'
import { useTheme } from '~/common/theme'
import styled, { css } from 'styled-components'

import { BORDER_RADIUS, COLORS, SIZES } from '~/common/globalStyles'

interface MenuItemContentProps {
  renderValue?: boolean
  noExtraPadding?: boolean
  drawerVersion?: boolean
  color?: keyof typeof COLORS
  'data-testid'?: string
}

export const MenuItemContent = styled.div<MenuItemContentProps>`
  display: flex;
  align-items: center;
  font-size: ${SIZES.small};
  border-radius: ${BORDER_RADIUS}px;
  padding: ${({ noExtraPadding }) =>
    noExtraPadding ? `0 ${SIZES.xxs}` : `0 ${SIZES.xxl} 0 ${SIZES.xxs}`};
  ${({ renderValue, color }) =>
    renderValue &&
    css`
      color: ${COLORS.white};
      background-color: ${color};
    `};
  ${({ drawerVersion }) =>
    drawerVersion &&
    css`
      height: ${SIZES.xxxl};
      border-radius: 0;
      font-size: ${SIZES.medium};
      padding: 0 ${SIZES.xxl} 0 ${SIZES.xl};
    `};
`

export const StatusDot = styled.div<MenuItemContentProps>`
  width: ${SIZES.small};
  height: ${SIZES.small};
  margin-right: ${SIZES.small};
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`

interface WrapperProps {
  drawerVersion?: boolean
}

const Wrapper = styled.div<WrapperProps>(
  ({ drawerVersion, theme }) => `
  display: flex;
  gap: ${theme.spacing(2)};
  align-items: center;
  ${
    !drawerVersion &&
    `
    flex-wrap: wrap;
    white-space: no-wrap;
    gap: ${theme.spacing(1)};
  `
  }
`,
)

interface SelectStatusOptionRowProps extends MenuItemContentProps {
  statusEnum?: {
    color(props: any): string
    displayName: string
  }
  'data-testid'?: string
}

const SelectStatusOptionRow: React.FC<SelectStatusOptionRowProps> = ({
  statusEnum,
  renderValue,
  drawerVersion,
  'data-testid': dataTestId,
  ...props
}) => {
  const theme = useTheme()
  if (!statusEnum) return null
  return (
    <MenuItemContent
      color={statusEnum.color({ theme }) as keyof typeof COLORS}
      renderValue={renderValue}
      drawerVersion={drawerVersion}
      data-testid={dataTestId || ''}
      {...props}
    >
      {!renderValue && (
        <StatusDot color={statusEnum.color({ theme }) as keyof typeof COLORS} />
      )}
      <Wrapper drawerVersion={drawerVersion}>{statusEnum.displayName}</Wrapper>
    </MenuItemContent>
  )
}

export default SelectStatusOptionRow
